<script>
import { mapGetters } from 'vuex';
import AnalysisSection from '@/components/Map/Analysis/AnalysisSection';
import Filters from '@/components/Map/Analysis/Filters';

export default {
  components: {
    AnalysisSection,
    Filters,
  },

  computed: {
    ...mapGetters(['study', 'screenData', 'activeAside']),
  },
};
</script>

<style lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/printAnalysis.scss';

.sub-view {
  position: fixed;
  background-color: rgba(#f4f4f4, 1);
  top: 104px;
  left: 55px;
  right: 0;
  bottom: 0;
  z-index: 1;
  color: colors.$near-dark-color;

  .sub-view-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    overflow: auto;
    transform: translateZ(0px);
    transition: left 0.5s cubic-bezier(0.72, 0.03, 0.28, 0.97);

    &.opened {
      left: 268px;
    }
  }
  .sub-view-gabarit {
    margin: auto;
    max-width: 900px;
    padding-top: 45px;
    padding-bottom: 45px;
  }

  .analysis-table {
    &:after {
      content: '';
      display: table;
      clear: both;
    }
  }
  .header-box {
    margin-bottom: 2em;

    h4 {
      font-size: 26px;
      font-weight: 600;
      margin-bottom: 0.2em;
    }

    p {
      font-size: 1em;
      font-style: italic;
      color: #828282;
      margin-top: 0.25em;
    }

    &:after {
      content: '';
      display: block;
      border-radius: 4px;
      width: 40px;
      height: 3px;
      background-color: colors.$red-active-color;
    }
  }

  .analysis-section {
    & > .heading {
      background-color: #f7f7f7;
      height: 64px;
      padding-left: 28px;

      h5 {
        font-size: 18px;
        font-weight: 600;
      }
    }
  }
}

.analysis-zone .analysis-section .main-content .table-body .table-row:nth-child(n + 5) {
  display: flex;
}

.analysis-zone {
  .analysis-section {
    background-color: colors.$white-color;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .td .value-block.red {
      color: #bc141a;
    }
    .td .value-block.orange {
      color: #ed700a;
    }
    .td .value-block.green {
      color: #1daea1;
    }
    & + .analysis-section {
      margin-top: 30px;
    }

    .bar-chart {
      padding-top: 60px;
      padding-right: 9.5555555556%;
      padding-bottom: 40px;
      padding-left: 9.5555555556%;

      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        height: 320px;
      }

      .tick text {
        fill: #000000;
        transform: translateY(12px);
      }
    }

    .line-chart {
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        height: 320px;
      }

      .tick text {
        fill: #000000;
        transform: translateY(4px);
      }

      .axis-y {
        .tick text {
          fill: #9d9c9c;
          font-size: 12px;
          transform: translateY(0px);
        }
      }
    }

    .main-content {
      .table-header {
        height: auto;
      }
    }
  }

  .main-content {
    margin: 18px auto auto;

    .table-gabarit {
      margin-left: auto;
      margin-right: auto;
    }

    .table-header {
      .td {
        &.big {
          flex: none;
          width: 236px;

          .value-block {
            text-align: left;
            margin-left: 25px;
          }
        }

        .value-block {
          font-size: 1em;

          .segment {
            font-weight: 700;
          }

          .sup-caption {
            font-weight: 400;
            font-size: 0.875em;
          }
        }
      }
      &.table-super-header .value-block .caption {
        color: #3c3c3b;
        font-size: 0.75em;
      }
    }

    .table-body {
      .table-row {
        .td {
          position: relative;

          &.big {
            flex: none;
            width: 236px;
          }

          .current-site-picture {
            width: 75px;
            margin: 0 16px 0 25px;
          }

          .site-picture {
            height: 57px;
            width: 75px;
            margin: 10px 16px 10px 25px;
            box-shadow: 0 2px 12px -4px rgba(0, 0, 0, 0.6);
            border-radius: 2px;
          }

          .details {
            overflow: hidden;

            span.title {
              font-size: 1em;
              font-weight: 700;
            }

            span.address {
              font-size: 0.65em;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }
          }

          .poi {
            height: 42px;

            margin-left: -31px;
            margin-bottom: -12px;
            width: 2em;
          }
        }

        & + .table-row {
          .table-gabarit {
            border-color: colors.$clear-border-color;
          }
        }
      }
    }

    .value-block {
      font-size: 1.125em;
      font-weight: 500;

      small {
        font-size: 0.875em;
      }
    }

    .heading {
      font-size: 0.75em;
      color: #9b9b9b;
      text-align: center;
    }
  }
}

.impact-summary-container {
  display: flex;
  margin-top: 14px;
  margin-bottom: 12px;
  justify-content: flex-start;
  flex-wrap: wrap;

  .impact-block {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    max-width: 225px;

    .site-box {
      width: 100%;
    }
  }

  .td {
    .site-picture {
      display: none;
    }
    .details {
      overflow: hidden;
      min-width: 145px;

      span.title {
        font-size: 1em;
        font-weight: 700;
      }
      span.address {
        font-size: 0.875em;
        overflow: hidden;
        height: 38px;
        display: -webkit-box;
        display: flex;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .poi {
      height: 42px;
      position: initial;
      left: -12px;
      bottom: 8px;
    }
  }
}

.exporting span.address {
  display: block !important;
}

.exporting {
  background: white;

  .table-button-container {
    display: none !important;
  }

  .impact-pie-container {
    width: auto;
    margin-right: auto;
    margin-left: auto;

    svg {
      margin: unset !important;
    }

    .label-box {
      width: calc(100% + 48px);
    }
  }
}
</style>
